<template>
  <div class="OverviewsStatisticsVisit flex justify-start items-start flex-col w-full">
    <div class="OverviewsItem w-full hover:bg-gray-100 text-sm flex items-end justify-between border-b border-gray-400 pb-2 px-2">
      <span class="font-bold">
        {{ visit.viewed }}
      </span>
      <span class="text-gray-400">
        {{ formatDate(visit.visitors[0].viewed, 'l') }}
      </span>
    </div>
    <div 
      v-for="visitor in visit.visitors"
      :key="visitor.user.id"
      class="OverviewsItemDetail flex justify-between items-center space-x-2 w-full hover:bg-gray-100 border-b border-gray-400 text-sm px-2"
    >
      <span class="">
        {{ visitor.user.label }}
      </span>
      <span class="text-gray-400">
        {{ formatDate(visitor.viewed, 'H:i') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visit: Object,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.OverviewsStatisticsVisit {
  .OverviewsItemDetail {
    height: 40px;
  }
}
</style>
